export { CameraIcon } from './camera'
